import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { classifyAddress, addressTypeLabel } from '@layerswap/utils';
const scopeLabel = ({ address, networkTypes }) => {
    const trimmed = (address ?? '').trim();
    if (!trimmed)
        return null;
    const types = networkTypes?.length ? networkTypes : classifyAddress(trimmed).types;
    if (!types.length)
        return 'Unrecognized';
    return types.map(addressTypeLabel).join(' / ');
};
const AddressBadge = ({ entry, duplicate }) => {
    const text = duplicate ? 'Already saved' : (entry ? scopeLabel(entry) : null);
    if (!text)
        return null;
    return (_jsxs("span", { className: clsx('inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium shrink-0', duplicate ? 'bg-error-foreground/10 text-error-foreground' : 'bg-secondary-300 text-secondary-text'), children: [_jsx("span", { className: clsx('w-1.5 h-1.5 rounded-full', duplicate ? 'bg-error-foreground' : 'bg-primary-text-tertiary') }), _jsx("span", { children: text })] }));
};
export default AddressBadge;
